import React from "react";
import { Routes, Route } from "react-router-dom";

// Reading
import ReadingMock from "../components/Mock/ReadingMock";
import ReadingIntro from "../components/Mock/ReadingIntro";

// Listening
import ListeningAudioPage from "../pages/ListeningAudioPage";
import ListeningQuestionsPage from "../pages/ListeningQuestionsPage";

// Writing
import WritingTask1Intro from "../components/Mock/WritingTask1Intro";
import WritingTask1Listening from "../components/Mock/WritingTask1Listening";
import WritingTask1Write from "../components/Mock/WritingTask1Write";
import WritingTask2 from "../components/Mock/WritingTask2";

// Review
import LessonReviewPage from "../pages/LessonReviewPage";
import FinalMockReviewPage from "../pages/FinalMockReviewPage";

export default function LessonMockRoutes({ mockId }) {
  return (
    <Routes>
      {/* 📖 Reading Section */}
      <Route path="reading" element={<ReadingIntro mockId={mockId} passageId={1} />} />
      <Route path="reading2" element={<ReadingIntro mockId={mockId} passageId={2} />} />
      <Route path="reading/:passageId/:questionId?" element={<ReadingMock mockId={mockId} />} />

      {/* 🎧 Listening Section */}
      <Route path="listening/:passageId/audio" element={<ListeningAudioPage />} />
      <Route path="listening/:passageId/questions" element={<ListeningQuestionsPage />} />

      {/* 📝 Writing Section */}
      <Route path="writing/1/intro" element={<WritingTask1Intro />} />
      <Route path="writing/1/listening" element={<WritingTask1Listening />} />
      <Route path="writing/1/write" element={<WritingTask1Write />} />
      <Route path="writing/2" element={<WritingTask2 />} />

      {/* 🏁 Final Review */}
      <Route path="review" element={<LessonReviewPage />} />
      <Route path="final" element={<FinalMockReviewPage />} />

    </Routes>
  );
}
